import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';

export const systemOutageApi = createApi({
  reducerPath: 'systemOutageApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SystemOutage'],
  endpoints: (builder) => ({
    getSystemOutageStatus: builder.query({
      query: () => ({
        url: '/api/system-outage/status',
        method: 'GET',
      }),
      providesTags: ['SystemOutage'],
    }),
    dismissSystemOutage: builder.mutation({
      query: (occurrenceId) => ({
        url: `/api/system-outage/${occurrenceId}/dismiss`,
        method: 'POST',
      }),
      invalidatesTags: ['SystemOutage'],
    }),
  }),
});

export const {
  useGetSystemOutageStatusQuery,
  useDismissSystemOutageMutation,
} = systemOutageApi;
